import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

interface TreatmentPageProps {
  title: string;
  description: string;
  causes: string[];
  symptoms: string[];
  approach: string;
  benefits: string[];
  lifestyleRecommendations: string[];
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}

const TreatmentPageTemplate: React.FC<TreatmentPageProps> = ({
  title,
  description,
  causes,
  symptoms,
  approach,
  benefits,
  lifestyleRecommendations,
  faqs
}) => {
  const location = useLocation();

  useEffect(() => {
    console.log(`${title} page mounted`);
    console.log('Current location:', location);
  }, [location, title]);

  return (
    <>
      <Header />
      <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
        <div className="container mx-auto px-4 max-w-3xl">
          {/* Breadcrumb navigation */}
          <div className="flex flex-wrap gap-2 mb-8">
            <Link to="/" className="text-swastik-blue hover:text-swastik-blue/70">Home</Link>
            <span className="text-gray-400">/</span>
            <Link to="/treatments" className="text-swastik-blue hover:text-swastik-blue/70">Treatments</Link>
            <span className="text-gray-400">/</span>
            <span className="text-gray-600">{title}</span>
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for {title}</h1>
          
          <section className="mb-8">
            <p>{description}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Causes</h2>
            <ul className="list-disc list-inside ml-4">
              {causes.map((cause, index) => (
                <li key={index}>{cause}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
            <ul className="list-disc list-inside ml-4">
              {symptoms.map((symptom, index) => (
                <li key={index}>{symptom}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
            <p>{approach}</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
            <ul className="list-disc list-inside ml-4">
              {benefits.map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
            <ul className="list-disc list-inside ml-4">
              {lifestyleRecommendations.map((recommendation, index) => (
                <li key={index}>{recommendation}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
            {faqs.map((faq, index) => (
              <div key={index} className="mb-4">
                <strong>Q{index + 1}: {faq.question}</strong>
                <p>A: {faq.answer}</p>
              </div>
            ))}
          </section>

          <section className="mb-8">
            <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
              <h3 className="text-xl font-semibold mb-2">Book your consultation today!</h3>
              <Link 
                to="/contact" 
                className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition"
              >
                Book Consultation
              </Link>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default TreatmentPageTemplate; 